import { matchPath } from "react-router-dom";
import { lazyWithPreload } from "./utils/lazyWithPreload";
import { stripLangPrefix } from "./utils/seoConfig";

const Home = lazyWithPreload(() => import("./pages/Home"));
const Labeling = lazyWithPreload(() => import("./pages/Labeling"));
const AnomalyDetection = lazyWithPreload(() => import("./pages/AnomalyDetection"));
const Pricing = lazyWithPreload(() => import("./pages/Pricing"));
const Services = lazyWithPreload(() => import("./pages/Services"));
const About = lazyWithPreload(() => import("./pages/About"));
const Blog = lazyWithPreload(() => import("./pages/Blog"));
const BlogPost = lazyWithPreload(() => import("./pages/BlogPost"));
const Impressum = lazyWithPreload(() => import("./pages/impressum"));
const PrivacyPolicy = lazyWithPreload(() => import("./pages/PrivacyPolicy"));
const Terms = lazyWithPreload(() => import("./pages/Terms"));
const CookiePolicy = lazyWithPreload(() => import("./pages/CookiePolicy"));
const LlmInfo = lazyWithPreload(() => import("./pages/LlmInfo"));
const SignUp = lazyWithPreload(() => import("./pages/SignUp"));
export const NotFound = lazyWithPreload(() => import("./pages/NotFound"));

// Putanje su bez jezičkog prefiksa; App ih registruje i pod "/de".
// Lista stranica za sitemap/prerender je u src/data/siteRoutes.json.
export const appRoutes = [
  { path: "/", Component: Home },
  { path: "/products/labeling", Component: Labeling },
  { path: "/products/anomaly-detection", Component: AnomalyDetection },
  { path: "/pricing", Component: Pricing },
  { path: "/services", Component: Services },
  { path: "/about", Component: About },
  { path: "/blog", Component: Blog },
  { path: "/blog/:slug", Component: BlogPost },
  { path: "/impressum", Component: Impressum },
  { path: "/privacy-policy", Component: PrivacyPolicy },
  { path: "/terms", Component: Terms },
  { path: "/cookie-policy", Component: CookiePolicy },
  { path: "/llm-info", Component: LlmInfo },
  { path: "/signup", Component: SignUp, bare: true },
];

export const findRoute = (pathname) => {
  const path = stripLangPrefix(pathname);
  return appRoutes.find((route) => matchPath(route.path, path)) || null;
};

// Učitava kod stranice za dati URL pre prvog rendera (bez treptanja prerenderovanog HTML-a)
export const preloadRoute = (pathname) => {
  const route = findRoute(pathname);
  return (route ? route.Component : NotFound).preload();
};
